import * as actionTypes from './actionTypes';

export const setExtracharge = (id: number, data: any) => ({
  type: actionTypes.SET_EXTRACHARGE,
  id,
  data
});

export const setExtrachargeAll = (data: any) => ({
  type: actionTypes.SET_EXTRACHARGE_ALL,
  data
});

export const setVignetteValue = (id: number, value: any) => ({
  type: actionTypes.SET_VIGNETTE_VALUE,
  id,
  value
});

export const selectExtracharge = (id: number, extraId: number, isActive: boolean, available?: number) => ({
  type: actionTypes.SELECT_EXTRACHARGE,
  id,
  extraId,
  isActive,
  available
});

export const clearExtrachargeAll = () => ({
  type: actionTypes.CLEAR_EXTRACHARGE_ALL
});

export const clearExtracharge = (id: number, quantity?: number, availables?) => ({
  type: actionTypes.CLEAR_EXTRACHARGE,
  id,
  quantity,
  availables
});

export const clearVignetteValue = (id: number) => ({
  type: actionTypes.CLEAR_VIGNETTE_VALUE,
  id
});

export const deleteExtrachargeData = () => ({
  type: actionTypes.DELETE_EXTRACHARGE_DATA
});
